import * as React from "react";
import { HighlightRectangle } from "kanopi-components/HighlightRectangle/HighlightRectangle";
import { isNullish } from "kanopi-components/utils/primitives";
import { PriceAvailableInline, PriceLoading, PriceUnavailable } from "./QuotePrice";

/* eslint-disable react/prop-types */

// TODO: Enable the proptype check next time when this file is changed

export function ExposurePrice(props) {
  const {
    periodicPrice,
    paymentFrequency,
    pricingFailed,
    loading,
    // inline = false,
    highlight = true,
    productKey,
  } = props;
  const content = (
    <>
      {loading && <PriceLoading />}
      {!loading &&
        (pricingFailed ? (
          "pricing failed"
        ) : isNullish(periodicPrice) ? (
          <PriceUnavailable />
        ) : (
          <PriceAvailableInline
            periodicPrice={periodicPrice}
            paymentFrequency={paymentFrequency}
            productKey={productKey}
          />
        ))}
    </>
  );
  return highlight ? (
    <HighlightRectangle {...{ minHeight: 0 }}>{content}</HighlightRectangle>
  ) : (
    content
  );
}
